import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

/**
 * İş modüllerine erişimi kısıtlayan guard.
 *
 * Yönlendirme mantığı:
 * - `account_status === "deleted"` → `/hesap-silinme-surecinde` (silinme
 *   uyarı ekranı; ödeme ekranı gösterilmez).
 * - `account_status === "passive"` veya `"archived"` → `/abonelik`
 *   (mevcut ödeme/abonelik ekranı).  Kullanıcı verileri korunur.
 * - `subscription_status === "paid"` veya `internal_free` (ve active) →
 *   serbest.
 * - `trial_expired === true` → `/abonelik`.
 *
 * Backend zaten aynı korumayı 402 ile uygular; bu guard yalnızca UX
 * için ekstra bir katman — kullanıcı 402 alacak API çağrılarına
 * ulaşmadan önce doğru sayfayı görür.
 */
export default function TrialGate() {
  const { user } = useAuth();
  const location = useLocation();

  if (!user) return null; // ProtectedRoute zaten login'e atar

  // Deleted hesap → ödeme ekranı YOK, sadece silinme uyarı ekranı.
  if (user.account_status === "deleted") {
    return <Navigate to="/hesap-silinme-surecinde" replace state={{ from: location.pathname }} />;
  }
  // Passive / Archived → mevcut abonelik ekranı ile aynı erişim mantığı.
  if (user.account_status === "passive" || user.account_status === "archived") {
    return <Navigate to="/abonelik" replace state={{ from: location.pathname }} />;
  }

  const eff = user.effective_subscription_status || (user.trial_expired ? "trial_expired" : user.subscription_status);
  // Bloke edilecek durumlar: trial süresi doldu, tolerans sonrası donmuş,
  // abonelik dönemi bitti.
  if (["trial_expired", "frozen", "expired"].includes(eff) || user.trial_expired) {
    return <Navigate to="/abonelik" replace state={{ from: location.pathname }} />;
  }
  return <Outlet />;
}
